import { validDailyCalorieTarget } from '@jungles/shared';

// Product defaults, not universal clinical prescriptions. The only current
// non-weight-change goal (maintain) is explicitly 0; unknown future goals fail closed.
// NICE NG246 1.16.8–11 reserves <=1200 kcal low-energy diets for supported care.
// Blocking that range is a narrow product guard, NOT a safety claim above it.
export function adjustCalorieGoal(maintenance: number, goal: unknown) {
  const percent = goal === 'cut' ? -10 : goal === 'mass' ? 10 : goal === 'maintain' ? 0 : null;
  if (percent === null || !validDailyCalorieTarget(maintenance)) return null;
  const target = Math.round(maintenance * (100 + percent) / 100);
  if (!validDailyCalorieTarget(target)) return null;
  return { maintenance, target, delta: target - maintenance, percent, blocked: target <= 1200 };
}

export function canApplyCalorieResult(preview: number | null, current: ReturnType<typeof adjustCalorieGoal>): boolean {
  return current !== null && !current.blocked && preview === current.target;
}
